﻿import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";

import { storylineReducer } from "./storyline/reducers";
import { appReducer } from "./app/reducers";
import { notificationsReducer } from "./notifications/reducers";
import { vsCodeReducer } from "./vscode/reducers";
import { diagnosticsReducer } from "./diagnostics/reducers";
import { profilingReducer } from "./profiling/reducers";
import { tracingReducer } from "./tracing/reducers";
import { traceStorylineMiddleware } from "./tracing/middleware";


export const store = configureStore({
    reducer: {
        app: appReducer,
        storyline: storylineReducer,
        notifications: notificationsReducer,
        vsCode: vsCodeReducer,
        diagnostics: diagnosticsReducer,
        profiling: profilingReducer,
        tracing: tracingReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }).concat(traceStorylineMiddleware),
    devTools: {
        serialize: {
            options: {
                map: true
            }
        }
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useThunkDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();